import React from "react";
import { useAppText } from "src/commun/composants/AppText";
import { useFormikContext } from "formik";
import AppCol from "src/commun/composants/grille/AppCol";
import { InfoPersoUpdate } from "src/pages/infoperso/infoperso/useValidationSchemaInfoPersoUpdate";
import AppRow from "src/commun/composants/grille/AppRow";
import AppInputFormik from "src/commun/composants/formulaire/formik/fields/AppInputFormik";
import TitreField from "src/commun/composants/formulaire/fields/TitreField";
import AppDatePickerFormik from "src/commun/composants/formulaire/formik/fields/AppDatePickerFormik";
import styles from "./InfoPersoUpdateFormContent.scss"
import TelephoneField from "src/commun/composants/formulaire/fields/TelephoneField";

export type InfoPersoUpdateFormContentProps = {
  readOnly: boolean;
}

const InfoPersoUpdateFormContent = ({ readOnly }: InfoPersoUpdateFormContentProps) => {
  const { tString } = useAppText();
  const { dirty, submitCount, submitForm } = useFormikContext<InfoPersoUpdate>();

  return (
    <>
      <AppRow>
        <h2 className={"appTitle"}>{tString("compte.mon.profile.infoPersonnel.title")}</h2>
      </AppRow>
      <AppRow>
        <AppCol md={{ offset: 4 }}>

          <div className="input mt-5 mb-5">
            <TitreField defaultValue={"compte.mon.profile.infoPersonnel.civilite.obligatoire"} disabled={readOnly}/>
          </div>
          <div className="input mt-3 mb-5">
            <AppInputFormik
              name="lastName"
              type="text"
              formulaireSoumis={submitCount > 0}
              disabled={readOnly}
            />
            <label className={`${readOnly && "txt-mediumish-gray"}`}>{tString("compte.mon.profile.infoPersonnel.nom")}</label>
          </div>
          <div className="input mt-3 mb-2">
            <AppInputFormik
              name="firstName"
              type="text"
              formulaireSoumis={submitCount > 0}
              disabled={readOnly}
            />
            <label className={`${readOnly && "txt-mediumish-gray"}`}>{tString("compte.mon.profile.infoPersonnel.prenom")}</label>
          </div>

          <AppDatePickerFormik
            name="birthdate"
            label={tString("compte.mon.profile.infoPersonnel.dateNaissance")}
            disabled={readOnly}
          />

          {readOnly ? (
            <div className="input mt-5 mb-2">
              <AppInputFormik
                name="telephonePro"
                type="text"
                disabled={readOnly}
              />
              <label className={`${readOnly && "txt-mediumish-gray"}`}>{tString("compte.mon.profile.infoPersonnel.telephonePro")}</label>
            </div>
          ) : (
            <div className="input mt-2 mb-2">
              <span className={styles.fieldLabel}>{tString("compte.mon.profile.infoPersonnel.telephonePro")}</span>
              <TelephoneField name="telephonePro" />
            </div>
          )}

          {!readOnly &&
            <input
              className="btn__primary mt-3 btn--full--xs"
              type="submit"
              name="submit"
              disabled={!dirty}
              onClick={submitForm}
              value={tString("action.sauvegarder")}
            />
          }
        </AppCol>
      </AppRow>
    </>
  );
};

export default InfoPersoUpdateFormContent;